import React from "react";


function ProductElements(props) {



    return(
        <div className="flex items-center space-x-3">
            <img
                src={props.image}
                alt={props.name}
                className="w-12 h-12 object-cover rounded"
            />
            <div className="flex-1">
                <h4 className="text-sm font-medium text-gray-800">{props.name}</h4>
                <p className="text-xs text-gray-500">Qty: {props.quantity}</p>
            </div>
            <span className="text-sm font-semibold text-brand-green">€{props.price}</span>
        </div>
    );
}

export default ProductElements;